import React from 'react';

import { PageEditorStore, PageEditorStoreContext } from '../store/PageEditorStore';
import { observer } from 'mobx-react-lite';
import { getInitialData } from 'ice';
import PageContentRender from './PageContentRender';

const pageEditorStore = new PageEditorStore();

const RenderHtml = observer(() => {
  const initialData = getInitialData();

  pageEditorStore.setIsRenderHtml(true);
  pageEditorStore.setIsDevelopment(false);
  pageEditorStore.setPage(initialData?.pageRenderConfig || {});

  return (
    <PageEditorStoreContext.Provider value={pageEditorStore}>
      <div style={{ backgroundColor: '#FFF' }} className={'pb-8 desc-page'}>
        <PageContentRender />
      </div>
    </PageEditorStoreContext.Provider>
  );
});

export default RenderHtml;
